import { Component } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'onyxride';
  norberto_img_source = 'norberto.jpg';
  norma_img_source = 'norma.jpg';

}
